var map = {
	"../dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard-dashboard-module"
	],
	"./admin/admin.module": [
		"./src/app/cpos-modules/admin/admin.module.ts",
		"common",
		"admin-admin-module"
	],
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"auth-auth-module"
	],
	"./batch-recall/batch-recall.module": [
		"./src/app/cpos-modules/batch-recall/batch-recall.module.ts",
		"batch-recall-batch-recall-module"
	],
	"./cpos-modules/cpos.module": [
		"./src/app/cpos-modules/cpos.module.ts",
		"default~cpos-modules-cpos-module~reports-reports-module",
		"cpos-modules-cpos-module"
	],
	"./export/export.module": [
		"./src/app/cpos-modules/export/export.module.ts",
		"export-export-module"
	],
	"./master/master.module": [
		"./src/app/cpos-modules/master/master.module.ts",
		"master-master-module"
	],
	"./payments/payments.module": [
		"./src/app/cpos-modules/payments/payments.module.ts",
		"payments-payments-module"
	],
	"./reports/reports.module": [
		"./src/app/cpos-modules/reports/reports.module.ts",
		"default~cpos-modules-cpos-module~reports-reports-module",
		"reports-reports-module"
	],
	"./sales/sales.module": [
		"./src/app/cpos-modules/sales/sales.module.ts",
		"sales-sales-module"
	],
	"./stock-return/stock-return.module": [
		"./src/app/cpos-modules/stock-return/stock-return.module.ts",
		"stock-return-stock-return-module"
	],
	"./stock/stock.module": [
		"./src/app/cpos-modules/stock/stock.module.ts",
		"stock-stock-module"
	],
	"./store-process/store-process.module": [
		"./src/app/cpos-modules/store-process/store-process.module.ts",
		"store-process-store-process-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;